import { TagSettings } from './types';

export const tagSettings: TagSettings = {
  componentVariants: {
    size: {
      prop: 'size',
      variants: {
        regular: {
          fontWeight: '2',
          borderRadius: '4',
          paddingTop: '2',
          paddingBottom: '2',
          paddingLeft: '3',
          paddingRight: '3',
        },
      },
    },
    color: {
      prop: 'color',
      variants: {
        primary: {
          color: 'primary.dark',
          backgroundColor: 'primary.light',
        },
        success: {
          color: 'success.dark',
          backgroundColor: 'success.light',
        },
        danger: {
          color: 'danger.dark',
          backgroundColor: 'danger.light',
        },
        gray: {
          color: 'gray.dark',
          backgroundColor: 'gray.light',
        },
      },
    },
  },
};
